<template>
  <nav class="nav p-2">
    <h2 class="nav__title">
      <router-link to="/">{{ title }}</router-link>
    </h2>
    <div class="search-container">
      <input v-model="search_input" @keyup.enter="navSearch" type="text" placeholder="Search.." name="Tìm kiếm">
      <button type="button" @click="navSearch">
        <font-awesome-icon icon="search"/>
      </button>
    </div>
    <transition-group  tag="menu" name="nav__item" class="nav__menu">
      <li v-for="label in labels" class="nav__item" :key="label" @click="navBack">
        <i class="nav__item--icon"></i>
        <span class="nav__item--label">{{ label }}</span>
      </li>
    </transition-group>
  </nav>
</template>

<script>
import { kebabify } from '../helpers'
export default {
  name: 'blog-nav',
  data() {
    return {
      search_input: this.$props.search || ''
    }
  },
  props: {
    navs: Number,
    content: Object,
    filters: {
      type: Object,
      default: () => {}
    },
    search: String
  },
  computed: {
    labels() {
      var filterLabels = Object.keys(this.filters)
        .map(filter => this.content.labels[filter]);
      if (this.$route.name === 'category') {
        filterLabels = [this.filters.category];
      }
      return filterLabels;
    },
    title() {
      return this.content.title;
    }
  },

  methods: {
    kebabify,
    navBack() {
      this.search_input = '';
      // if (this.navs && !this.filters.author) {
      //   if (this.$router.name === 'slug') {
      //     this.$emit('clearFeed');
      //   }
      //   this.$router.go(-1);
      // } else {
      //   this.$router.push('/')
      // }
      this.$router.push('/')
    },
    navSearch() {
      if (this.search_input !== '') {
        this.$router.push(`/search/${kebabify(this.search_input)}`);
      }
    }
  },
  watch: {
    search: function(val) {
      this.search_input = val;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BlogNav.vue